<template>
  <div class="user">
    <div class="user__header">
      <h1 class="user__header__title medium-title">Add New User</h1>
    </div>
    <div class="user__content">
      <div class="user__content__info">
        <div class="payment__content__info__field">
        <adx-input :ref="dataRef.fullName" :label="`Full Name *`" :error.sync="fullNameError" :validation="['NotEmpty', 'MinLength:2', 'MaxLength:100']" :value.sync="fullName" />
        </div>
      </div>
      <div class="user__content__info">
        <div class="header">
          <span class="subhead strong">User Information</span>
        </div>
        <div class="user__content__info__field">
          <adx-input :ref="dataRef.email" :label="`Email Address *`" :error.sync="emailError" :validation="['NotEmpty', 'Email']"  :value.sync="email" />
        </div>
        <div class="user__content__info__field">
          <adx-input :ref="dataRef.mobile" :label="`Phone Number *`" :error.sync="mobileError" :validation="['NotEmpty', 'Phone', 'Numeric', 'MinLength:7', 'MaxLength:15']" :value.sync="mobile" />
        </div>
        <div class="user__content__info__field">
          <adx-input :label="`Company Name`" :error="companyError" :value.sync="company" />
        </div>
        <div class="user__content__info__fields">
          <adx-dropdown :value.sync="idType" :type="true" :label="`ID Type`" :options="defaultIDType" />
          <adx-input :ref="dataRef.idNumber" :label="`ID Number`" :error.sync="idNumberError" :validation="[`MinLength:${minLength}`, `MaxLength:${maxLength}`]" :value.sync="idNumber" />
        </div>
      </div>
      <div class="user__content__info">
        <div class="header">
          <span class="subhead strong">Bank Information</span>
        </div>
        <div class="user__content__info__fields">
          <adx-input :ref="dataRef.bankName" :label="`Bank Name *`" :error.sync="bankNameError" :validation="['NotEmpty', 'MinLength:2', 'MaxLength:50']" :value.sync="bankName" />
          <adx-input :label="`Branch`" :error.sync="bankBranchError" :validation="['MaxLength:50']" :value.sync="bankBranch" />
        </div>
        <div class="user__content__info__field">
          <adx-input :ref="dataRef.accountName" :label="`Account Name *`" :error.sync="accountNameError" :validation="['NotEmpty', 'MinLength:2', 'MaxLength:50']" :value.sync="accountName" />
        </div>
        <div class="user__content__info__field">
          <adx-input :ref="dataRef.accountNumber" :label="`Account Number *`" :error.sync="accountNumberError" :validation="['NotEmpty', 'Numeric', 'MaxLength:15']" :value.sync="accountNumber" />
        </div>
      </div>
      <div class="user__content__button">
        <button 
          type="button" 
          :class="['primary', 'btn-large', 'btn-checkout-large', isSaving ? 'disabled' : '']" 
          :disabled="isSaving"
          @click="saveUser">
          Save User
          <adx-loading-circle v-if="isSaving" class="loading-circle"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/Form/Input'
import Dropdown from '@/components/Form/SelectDropdown'
import LoadingCircle from '@/components/Loading/Secondary-white'
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-',
  components: {
    'adx-input': Input,
    'adx-dropdown': Dropdown,
    'adx-loading-circle': LoadingCircle
  },
  props: {

  },
  data() {
    return {
      dataRef: {
        fullName: 'fullName',
        email: 'email',
        mobile: 'mobile',
        idNumber: 'idNumber',
        bankName: 'bankName',
        accountName: 'accountName',
        accountNumber: 'accountNumber'
      },
      mapDataAPI: {
        // api key: front end key (from dataRef key)
        full_name: 'fullName',
        email: 'email',
        mobile: 'mobile',
        id_number: 'idNumber',
        bank_name: 'bankName',
        account_name: 'accountName',
        account_number: 'accountNumber'
      },
      isSaving: false,
      fullName: '',
      email: '',
      mobile: '',
      company: '',
      idType: '',
      idNumber: '0000000000000000',
      bankName: 'BANKNAME',
      bankBranch: 'BRANCH',
      accountName: 'ACCOUNTNAME',
      accountNumber: '000000000000000',
      fullNameError: '',
      emailError: '',
      mobileError: '',
      companyError: '',
      idTypeError: '',
      idNumberError: '',
      bankNameError: '',
      bankBranchError: '',
      accountNameError: '',
      accountNumberError: '',
      defaultIDType: [
        {
          id: 0,
          label: `KTP`,
          value: `ktp`
        },
        {
          id: 1,
          label: `NPWP`,
          value: `npwp`
        }
      ],
      minLength: 16,
      maxLength: 16
    }
  },
  computed: {

  },
  watch: {
    idType(newValue, oldValue) {
      if (newValue.toLowerCase() == 'ktp') {
        this.minLength = 16
        this.maxLength = 16
      } else {
        this.minLength = 15
        this.maxLength = 15
      }
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    const groups = this.$store.getters.groups.split(',')
    if (groups.includes('user_manager')) {
      this.idType = this.defaultIDType[0].value
    } else {
      this.$router.replace({ name: '403' })
    }
  },
  mounted() {
    
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    saveUser() {
      let validation = this.validate_user_info()
      if (validation.isValid) {
        (async () => {
          this.isSaving = true
          let data = {
            full_name: this.fullName,
            email: this.email,
            mobile: this.mobile,
            company: this.company,
            id_type: this.idType,
            id_number: this.idNumber,
            bank_name: this.bankName,
            bank_branch: this.bankBranch,
            account_name: this.accountName,
            account_number: this.accountNumber
          }
          let response = await api.post(apiV2.signupWithGeneratedPassword, data, {needToken: true})
          if (response.status == 201) {
            this.isSaving = false
            this.$notify({
              group: 'saved',
              title: `${response.data.message}`,
              text: `Email has been sent to “${this.email}”.`,
              type: 'success'
            })
          } else if (response.status == 400) {
            this.isSaving = false
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: `${response.data.message}`,
              type: 'danger'
            });
          }
        })();
      } else {
        this.raiseError(validation.id)
      }
    },
    validate_user_info() {
      let data = { isValid: true, id: null }
      let dataRef = this.dataRef

      for (let key in this.dataRef) {
        let element = this.$refs[key].$el.firstElementChild
        let value = element.value
        if (key == dataRef.idNumber && !value) {
          continue
        } else if (!value || this.inputInvalid(dataRef[key])) {
          data.isValid = false
          data.id = this.dataRef[key]
          break
        }
      }

      return data
    },
    raiseError(id) {
      let element = this.$refs[id].$el.firstElementChild
      element.focus()
      element.blur()
    },
    inputInvalid(value) {
      let error = false
      let dataRef = this.dataRef
      switch(value) {
        case dataRef.fullName:
          error = this.fullNameError
          break
        case dataRef.email:
          error = this.emailAddressError
          break
        case dataRef.mobile:
          error = this.mobileError
          break
        case dataRef.idNumber:
          error = this.idNumberError
          break
        case dataRef.bankName:
          error = this.bankNameError
          break
        case dataRef.accountName:
          error = this.accountNameError
          break
        case dataRef.accountNumber:
          error = this.accountNumberError
          break
      }

      return error
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
.user__content__info__fields {
  .selectDropdown {
    .select {
      .standardInput {
        padding: 16px !important;
      }
    }
  }
}
</style>